import React from "react";
import general from "../../../../../../general";
import CustomCardBase from "./CustomCardBase";

// subType=1 活动
export default function ActivityMessage({ msg }) {
  const { attach } = msg;
  return (
    <CustomCardBase
      tagColor="#6167E0"
      tagText="活动"
      title={attach?.news_title}
      gameInfo={attach?.game_info}
      desc={attach?.new_content}
      descClass="imc-line2"
      onClick={() => {
        general.game = attach?.game_info;
        general.history.push("/article/detail?id=" + attach?.news_id + "&type=activity");
      }}
    />
  );
}
